import { render } from "./protect_group.vue?vue&type=template&id=af167be2"
import script from "./protect_group.vue?vue&type=script&lang=js"
export * from "./protect_group.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__